const DOMINIOS_VENDEDORA = [
  '@fastenglish.com.mx',
  '@inbi.mx',
  '@globalsyntax.com.mx',
]

/** Alumno = matrícula numérica. Cualquier texto con @ va a api-rh. */
export function esCorreoVendedora (valor) {
  const s = String(valor || '').trim()
  return s.indexOf('@') !== -1
}

export { DOMINIOS_VENDEDORA }
